import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import axios from "axios";
import Tabela from "../../Componentes/Utils/Tabela";
import styled from "styled-components";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import ModalRepAloj from "./ModalRepAloj";
import ModalQuartoEdit from "./ModalQuartoEdit";
import ModalQuartoDelete from "./ModalQuartoDelete";

const TableCell = styled.td`
    color: #000;
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`;
const AcoesCell = styled.td`
    width: 125px;
`
const AcoesContainer = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
`
const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 18px;
        transition: color 0.2s;
    }

    &:hover svg {
        color: ${(props) => props.hoverColor || "#000"};
    }
`;

const ContainerHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
`
const ContainerTitle = styled.h2`
    color: #333;
    margin: 0;
`
const ContainerButton = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.2s;
    &:hover {
        background-color: #1e40af;
        scale: 1.05;
    }
`

const ModalRepQuartos = ({ rep, fetchReps }) => {

    const { closeModal, openModal, isModalOpen } = useModal();

    const [loading, setLoading] = useState(true);

    const [quartos, setQuartos] = useState([]);

    const fetchQuartos = async () => {

        setLoading(true);

        try {
            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/GetQuartos/?id=${rep.identifier}`)
            setQuartos(data);
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchQuartos();
    }, [])

    const [selectedQuarto, setSelectedQuarto] = useState(null);

    const openAlojadosView = (quarto) => {

        console.log(quarto);

        setSelectedQuarto(quarto);
        openModal('viewAlojados');

    }

    const openEditQuarto = (quarto = null) => {

        setSelectedQuarto(quarto);
        openModal('editQuarto');

    }

    const openDeleteQuarto = (quarto = null) => {
        setSelectedQuarto(quarto);
        openModal('deleteQuarto');
    }


    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header={true} close={closeModal} >
                    <ContainerHeader>
                        <ContainerTitle>Quartos da república: {rep.apelido_rep}</ContainerTitle>
                        <ContainerButton
                            onClick={() => openEditQuarto()}
                        >NOVO QUARTO</ContainerButton>
                    </ContainerHeader>
                    <Tabela loading={loading} >
                        <thead>
                            <tr>
                                <th>QUARTO</th>
                                <th>VAGAS</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {quartos.map((obj) => (
                                <tr key={obj.identifier} >
                                    <TableCell>{obj.quarto_name}</TableCell>
                                    <TableCell align="center" >{obj.alojados}/{obj.vagas}</TableCell>
                                    <AcoesCell>
                                        <AcoesContainer>
                                            <IconButton
                                                hoverColor="#16a34a"
                                                onClick={() => openAlojadosView(obj)}
                                            >
                                                <FaEye />
                                            </IconButton>
                                            <IconButton
                                                hoverColor="#1d4ed8"
                                                onClick={() => openEditQuarto(obj)}
                                            >
                                                <FaEdit />
                                            </IconButton>
                                            <IconButton
                                                hoverColor="#dc2626"
                                                onClick={() => openDeleteQuarto(obj)}
                                            >
                                                <FaTrash />
                                            </IconButton>
                                        </AcoesContainer>
                                    </AcoesCell>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {isModalOpen('viewAlojados') && (
                <ModalRepAloj
                    quarto={selectedQuarto}
                />
            )}
            {isModalOpen('editQuarto') && (
                <ModalQuartoEdit
                    quarto={selectedQuarto}
                    republica={rep.identifier}
                    fetchQuartos={fetchQuartos}
                    fetchReps={fetchReps}
                />
            )}
            {isModalOpen('deleteQuarto')&&(
                <ModalQuartoDelete
                    quarto={selectedQuarto}
                    fetchQuartos={fetchQuartos}
                    fetchReps={fetchReps}
                />
            )}
        </>
    )
}

export default ModalRepQuartos;